/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfigurationListResponse,
  ConfigurationResponse,
  XsoarAccountMappingListResponse,
  XsoarAccountMappingResponse,
  XsoarHealthUpdateRequest,
} from '../models/index';
import {
    ConfigurationListResponseFromJSON,
    ConfigurationListResponseToJSON,
    ConfigurationResponseFromJSON,
    ConfigurationResponseToJSON,
    XsoarAccountMappingListResponseFromJSON,
    XsoarAccountMappingListResponseToJSON,
    XsoarAccountMappingResponseFromJSON,
    XsoarAccountMappingResponseToJSON,
    XsoarHealthUpdateRequestFromJSON,
    XsoarHealthUpdateRequestToJSON,
} from '../models/index';

export interface CreateOrUpdateXsoarAccountMappingRequest {
    xsoarAccountId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
    tenantIds?: string;
}

export interface DeleteXsoarAccountMappingRequest {
    xsoarAccountId: string;
}

export interface GetAvailableTenantsRequest {
    sessionId?: string;
}

export interface GetXsoarAccountHealthRequest {
    xsoarAccountId: string;
    sessionId?: string;
}

export interface GetXsoarAccountMappingRequest {
    xsoarAccountId: string;
    sessionId?: string;
}

export interface GetXsoarAccountMappingsRequest {
    tenantIds?: string;
}

export interface GetXsoarIntegrationConfigurationRequest {
    sessionId?: string;
}

export interface GetXsoarIntegrationConfigurationsRequest {
    sessionId?: string;
}

export interface UpdateSyncModeRequest {
    syncMode: UpdateSyncModeSyncModeEnum;
    sessionId?: string;
}

export interface UpdateXsoarAccountHealthRequest {
    xsoarAccountId: string;
    xsoarHealthUpdateRequest: XsoarHealthUpdateRequest;
    sessionId?: string;
}

export interface ValidateXsoarAccountMappingRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

/**
 * XsoarIntegrationControllerApi - interface
 * 
 * @export
 * @interface XsoarIntegrationControllerApiInterface
 */
export interface XsoarIntegrationControllerApiInterface {
    /**
     * Creates or updates an XSOAR account mapping with flexible tenant selection
     * @summary Create or update XSOAR account mapping
     * @param {string} xsoarAccountId XSOAR Account ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {string} [tenantIds] Comma-separated list of tenant IDs to override session tenant selection.  **IMPORTANT:** For XSOAR account mapping creation/update, only the FIRST tenant ID will be used. Account mappings must be created/updated in a single tenant.  **Example:** &#x60;tenantIds&#x3D;f38c4e40-51a1-4b84-a3b4-5c08446adf32&#x60;  If not provided, the mapping will be created/updated in the session\&#39;s current tenant.  **Note:** The @TenantSelection aspect handles tenant validation and context setup automatically. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XsoarIntegrationControllerApiInterface
     */
    createOrUpdateXsoarAccountMappingRaw(requestParameters: CreateOrUpdateXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Creates or updates an XSOAR account mapping with flexible tenant selection
     * Create or update XSOAR account mapping
     */
    createOrUpdateXsoarAccountMapping(requestParameters: CreateOrUpdateXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Deletes an XSOAR account mapping with flexible tenant selection
     * @summary Delete XSOAR account mapping
     * @param {string} xsoarAccountId XSOAR Account ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XsoarIntegrationControllerApiInterface
     */
    deleteXsoarAccountMappingRaw(requestParameters: DeleteXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Deletes an XSOAR account mapping with flexible tenant selection
     * Delete XSOAR account mapping
     */
    deleteXsoarAccountMapping(requestParameters: DeleteXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves list of tenants the user has access to for XSOAR integration configuration
     * @summary Get available tenants for XSOAR integration
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XsoarIntegrationControllerApiInterface
     */
    getAvailableTenantsRaw(requestParameters: GetAvailableTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves list of tenants the user has access to for XSOAR integration configuration
     * Get available tenants for XSOAR integration
     */
    getAvailableTenants(requestParameters: GetAvailableTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves the stored health status for an XSOAR account mapping.  This endpoint returns the health status that was previously set via PUT /accounts/{xsoarAccountId}/health, including: - Last sync timestamp - Sync status (success, failed, partial, in progress) - Sync details (number of records synced, errors, etc.) - Error messages if any - Integration status  **Use Case:** Use this endpoint to retrieve the sync status, including number of records synced, errors, and other metrics stored in sync_details. 
     * @summary Get XSOAR account health status
     * @param {string} xsoarAccountId XSOAR Account ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XsoarIntegrationControllerApiInterface
     */
    getXsoarAccountHealthRaw(requestParameters: GetXsoarAccountHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XsoarAccountMappingResponse>>;

    /**
     * Retrieves the stored health status for an XSOAR account mapping.  This endpoint returns the health status that was previously set via PUT /accounts/{xsoarAccountId}/health, including: - Last sync timestamp - Sync status (success, failed, partial, in progress) - Sync details (number of records synced, errors, etc.) - Error messages if any - Integration status  **Use Case:** Use this endpoint to retrieve the sync status, including number of records synced, errors, and other metrics stored in sync_details. 
     * Get XSOAR account health status
     */
    getXsoarAccountHealth(requestParameters: GetXsoarAccountHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XsoarAccountMappingResponse>;

    /**
     * Retrieves a specific XSOAR account mapping by account ID
     * @summary Get XSOAR account mapping by ID
     * @param {string} xsoarAccountId XSOAR Account ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XsoarIntegrationControllerApiInterface
     */
    getXsoarAccountMappingRaw(requestParameters: GetXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XsoarAccountMappingResponse>>;

    /**
     * Retrieves a specific XSOAR account mapping by account ID
     * Get XSOAR account mapping by ID
     */
    getXsoarAccountMapping(requestParameters: GetXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XsoarAccountMappingResponse>;

    /**
     * Retrieves all XSOAR account mappings with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    returns account mappings from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the tenant IDs provided in the `tenantIds` parameter 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Returns account mappings aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Format:** Comma-separated list of tenant IDs **Example:** `tenant-abc123,tenant-def456` **Validation:** All specified tenants must be in user\'s authorized tenant list 
     * @summary Get all XSOAR account mappings with flexible tenant selection
     * @param {string} [tenantIds] **OVERRIDE PARAMETER - Optional tenant selection override**  **When NOT provided (DEFAULT BEHAVIOR):** - Uses &#x60;tenantIsolationService.getEffectiveTenantIds(sessionId)&#x60; - Returns selectedTenants from the user\&#39;s session - If no tenants selected in session, uses current tenant only  **When provided (OVERRIDE BEHAVIOR):** - Ignores session tenant selection completely - Uses only the specified tenant IDs - Validates user has access to all requested tenants  **Format:** Comma-separated list of tenant IDs **Example:** &#x60;tenant-abc123,tenant-def456&#x60; **Validation:** All specified tenants must be in user\&#39;s authorized tenant list  **Use Cases:** - Default: &#x60;GET /api/v1/xsoar-integration/accounts?sessionId&#x3D;abc123&#x60; (uses session selection) - Override: &#x60;GET /api/v1/xsoar-integration/accounts?sessionId&#x3D;abc123&amp;tenantIds&#x3D;tenant1,tenant2&#x60; (ignores session) 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XsoarIntegrationControllerApiInterface
     */
    getXsoarAccountMappingsRaw(requestParameters: GetXsoarAccountMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XsoarAccountMappingListResponse>>;

    /**
     * Retrieves all XSOAR account mappings with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    returns account mappings from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the tenant IDs provided in the `tenantIds` parameter 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Returns account mappings aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Format:** Comma-separated list of tenant IDs **Example:** `tenant-abc123,tenant-def456` **Validation:** All specified tenants must be in user\'s authorized tenant list 
     * Get all XSOAR account mappings with flexible tenant selection
     */
    getXsoarAccountMappings(requestParameters: GetXsoarAccountMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XsoarAccountMappingListResponse>;

    /**
     * Retrieves XSOAR integration configuration in ConfigurationDto format
     * @summary Get XSOAR integration configuration
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XsoarIntegrationControllerApiInterface
     */
    getXsoarIntegrationConfigurationRaw(requestParameters: GetXsoarIntegrationConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>>;

    /**
     * Retrieves XSOAR integration configuration in ConfigurationDto format
     * Get XSOAR integration configuration
     */
    getXsoarIntegrationConfiguration(requestParameters: GetXsoarIntegrationConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse>;

    /**
     * Retrieves all XSOAR integration configurations in ConfigurationDto format
     * @summary Get XSOAR integration configurations
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XsoarIntegrationControllerApiInterface
     */
    getXsoarIntegrationConfigurationsRaw(requestParameters: GetXsoarIntegrationConfigurationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationListResponse>>;

    /**
     * Retrieves all XSOAR integration configurations in ConfigurationDto format
     * Get XSOAR integration configurations
     */
    getXsoarIntegrationConfigurations(requestParameters: GetXsoarIntegrationConfigurationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationListResponse>;

    /**
     * Updates the sync mode for XSOAR integration configuration.  **Sync Modes:** - `backfill`: One-directional load from XSOAR into this system (read-only from XSOAR) - `bi-directional`: Two-way synchronization between XSOAR and this system  **Default:** `bi-directional`  **Note:** This setting applies to the entire XSOAR integration configuration for the tenant. 
     * @summary Update XSOAR integration sync mode
     * @param {'backfill' | 'bi-directional'} syncMode Sync mode: \&#39;backfill\&#39; or \&#39;bi-directional\&#39;
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XsoarIntegrationControllerApiInterface
     */
    updateSyncModeRaw(requestParameters: UpdateSyncModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Updates the sync mode for XSOAR integration configuration.  **Sync Modes:** - `backfill`: One-directional load from XSOAR into this system (read-only from XSOAR) - `bi-directional`: Two-way synchronization between XSOAR and this system  **Default:** `bi-directional`  **Note:** This setting applies to the entire XSOAR integration configuration for the tenant. 
     * Update XSOAR integration sync mode
     */
    updateSyncMode(requestParameters: UpdateSyncModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Updates the health status for an XSOAR account mapping.  This endpoint is called by external bi-directional cases sync services to report: - Last sync timestamp - Sync status (success, failed, partial) - Sync details (number of records synced, errors, etc.) - Error messages if any - Integration status  **Use Case:** External sync services should call this endpoint after each sync operation to populate the status of the sync (# records sync\'d, errors, etc.). 
     * @summary Update XSOAR account health status
     * @param {string} xsoarAccountId XSOAR Account ID
     * @param {XsoarHealthUpdateRequest} xsoarHealthUpdateRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XsoarIntegrationControllerApiInterface
     */
    updateXsoarAccountHealthRaw(requestParameters: UpdateXsoarAccountHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XsoarAccountMappingResponse>>;

    /**
     * Updates the health status for an XSOAR account mapping.  This endpoint is called by external bi-directional cases sync services to report: - Last sync timestamp - Sync status (success, failed, partial) - Sync details (number of records synced, errors, etc.) - Error messages if any - Integration status  **Use Case:** External sync services should call this endpoint after each sync operation to populate the status of the sync (# records sync\'d, errors, etc.). 
     * Update XSOAR account health status
     */
    updateXsoarAccountHealth(requestParameters: UpdateXsoarAccountHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XsoarAccountMappingResponse>;

    /**
     * Validates XSOAR account mapping data without saving
     * @summary Validate XSOAR account mapping data
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XsoarIntegrationControllerApiInterface
     */
    validateXsoarAccountMappingRaw(requestParameters: ValidateXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Validates XSOAR account mapping data without saving
     * Validate XSOAR account mapping data
     */
    validateXsoarAccountMapping(requestParameters: ValidateXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class XsoarIntegrationControllerApi extends runtime.BaseAPI implements XsoarIntegrationControllerApiInterface {

    /**
     * Creates or updates an XSOAR account mapping with flexible tenant selection
     * Create or update XSOAR account mapping
     */
    async createOrUpdateXsoarAccountMappingRaw(requestParameters: CreateOrUpdateXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['xsoarAccountId'] == null) {
            throw new runtime.RequiredError(
                'xsoarAccountId',
                'Required parameter "xsoarAccountId" was null or undefined when calling createOrUpdateXsoarAccountMapping().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling createOrUpdateXsoarAccountMapping().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/xsoar-integration/accounts/{xsoarAccountId}`;
        urlPath = urlPath.replace(`{${"xsoarAccountId"}}`, encodeURIComponent(String(requestParameters['xsoarAccountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Creates or updates an XSOAR account mapping with flexible tenant selection
     * Create or update XSOAR account mapping
     */
    async createOrUpdateXsoarAccountMapping(requestParameters: CreateOrUpdateXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createOrUpdateXsoarAccountMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an XSOAR account mapping with flexible tenant selection
     * Delete XSOAR account mapping
     */
    async deleteXsoarAccountMappingRaw(requestParameters: DeleteXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['xsoarAccountId'] == null) {
            throw new runtime.RequiredError(
                'xsoarAccountId',
                'Required parameter "xsoarAccountId" was null or undefined when calling deleteXsoarAccountMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/xsoar-integration/accounts/{xsoarAccountId}`;
        urlPath = urlPath.replace(`{${"xsoarAccountId"}}`, encodeURIComponent(String(requestParameters['xsoarAccountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Deletes an XSOAR account mapping with flexible tenant selection
     * Delete XSOAR account mapping
     */
    async deleteXsoarAccountMapping(requestParameters: DeleteXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deleteXsoarAccountMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves list of tenants the user has access to for XSOAR integration configuration
     * Get available tenants for XSOAR integration
     */
    async getAvailableTenantsRaw(requestParameters: GetAvailableTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/xsoar-integration/available-tenants`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves list of tenants the user has access to for XSOAR integration configuration
     * Get available tenants for XSOAR integration
     */
    async getAvailableTenants(requestParameters: GetAvailableTenantsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAvailableTenantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the stored health status for an XSOAR account mapping.  This endpoint returns the health status that was previously set via PUT /accounts/{xsoarAccountId}/health, including: - Last sync timestamp - Sync status (success, failed, partial, in progress) - Sync details (number of records synced, errors, etc.) - Error messages if any - Integration status  **Use Case:** Use this endpoint to retrieve the sync status, including number of records synced, errors, and other metrics stored in sync_details. 
     * Get XSOAR account health status
     */
    async getXsoarAccountHealthRaw(requestParameters: GetXsoarAccountHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XsoarAccountMappingResponse>> {
        if (requestParameters['xsoarAccountId'] == null) {
            throw new runtime.RequiredError(
                'xsoarAccountId',
                'Required parameter "xsoarAccountId" was null or undefined when calling getXsoarAccountHealth().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/xsoar-integration/accounts/{xsoarAccountId}/health`;
        urlPath = urlPath.replace(`{${"xsoarAccountId"}}`, encodeURIComponent(String(requestParameters['xsoarAccountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => XsoarAccountMappingResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the stored health status for an XSOAR account mapping.  This endpoint returns the health status that was previously set via PUT /accounts/{xsoarAccountId}/health, including: - Last sync timestamp - Sync status (success, failed, partial, in progress) - Sync details (number of records synced, errors, etc.) - Error messages if any - Integration status  **Use Case:** Use this endpoint to retrieve the sync status, including number of records synced, errors, and other metrics stored in sync_details. 
     * Get XSOAR account health status
     */
    async getXsoarAccountHealth(requestParameters: GetXsoarAccountHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XsoarAccountMappingResponse> {
        const response = await this.getXsoarAccountHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific XSOAR account mapping by account ID
     * Get XSOAR account mapping by ID
     */
    async getXsoarAccountMappingRaw(requestParameters: GetXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XsoarAccountMappingResponse>> {
        if (requestParameters['xsoarAccountId'] == null) {
            throw new runtime.RequiredError(
                'xsoarAccountId',
                'Required parameter "xsoarAccountId" was null or undefined when calling getXsoarAccountMapping().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/xsoar-integration/accounts/{xsoarAccountId}`;
        urlPath = urlPath.replace(`{${"xsoarAccountId"}}`, encodeURIComponent(String(requestParameters['xsoarAccountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => XsoarAccountMappingResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific XSOAR account mapping by account ID
     * Get XSOAR account mapping by ID
     */
    async getXsoarAccountMapping(requestParameters: GetXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XsoarAccountMappingResponse> {
        const response = await this.getXsoarAccountMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all XSOAR account mappings with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    returns account mappings from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the tenant IDs provided in the `tenantIds` parameter 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Returns account mappings aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Format:** Comma-separated list of tenant IDs **Example:** `tenant-abc123,tenant-def456` **Validation:** All specified tenants must be in user\'s authorized tenant list 
     * Get all XSOAR account mappings with flexible tenant selection
     */
    async getXsoarAccountMappingsRaw(requestParameters: GetXsoarAccountMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XsoarAccountMappingListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/xsoar-integration/accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => XsoarAccountMappingListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all XSOAR account mappings with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    returns account mappings from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the tenant IDs provided in the `tenantIds` parameter 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Returns account mappings aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Format:** Comma-separated list of tenant IDs **Example:** `tenant-abc123,tenant-def456` **Validation:** All specified tenants must be in user\'s authorized tenant list 
     * Get all XSOAR account mappings with flexible tenant selection
     */
    async getXsoarAccountMappings(requestParameters: GetXsoarAccountMappingsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XsoarAccountMappingListResponse> {
        const response = await this.getXsoarAccountMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves XSOAR integration configuration in ConfigurationDto format
     * Get XSOAR integration configuration
     */
    async getXsoarIntegrationConfigurationRaw(requestParameters: GetXsoarIntegrationConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/xsoar-integration/configuration`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves XSOAR integration configuration in ConfigurationDto format
     * Get XSOAR integration configuration
     */
    async getXsoarIntegrationConfiguration(requestParameters: GetXsoarIntegrationConfigurationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse> {
        const response = await this.getXsoarIntegrationConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all XSOAR integration configurations in ConfigurationDto format
     * Get XSOAR integration configurations
     */
    async getXsoarIntegrationConfigurationsRaw(requestParameters: GetXsoarIntegrationConfigurationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/xsoar-integration/configurations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all XSOAR integration configurations in ConfigurationDto format
     * Get XSOAR integration configurations
     */
    async getXsoarIntegrationConfigurations(requestParameters: GetXsoarIntegrationConfigurationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationListResponse> {
        const response = await this.getXsoarIntegrationConfigurationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the sync mode for XSOAR integration configuration.  **Sync Modes:** - `backfill`: One-directional load from XSOAR into this system (read-only from XSOAR) - `bi-directional`: Two-way synchronization between XSOAR and this system  **Default:** `bi-directional`  **Note:** This setting applies to the entire XSOAR integration configuration for the tenant. 
     * Update XSOAR integration sync mode
     */
    async updateSyncModeRaw(requestParameters: UpdateSyncModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['syncMode'] == null) {
            throw new runtime.RequiredError(
                'syncMode',
                'Required parameter "syncMode" was null or undefined when calling updateSyncMode().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['syncMode'] != null) {
            queryParameters['syncMode'] = requestParameters['syncMode'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/xsoar-integration/configuration/sync-mode`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates the sync mode for XSOAR integration configuration.  **Sync Modes:** - `backfill`: One-directional load from XSOAR into this system (read-only from XSOAR) - `bi-directional`: Two-way synchronization between XSOAR and this system  **Default:** `bi-directional`  **Note:** This setting applies to the entire XSOAR integration configuration for the tenant. 
     * Update XSOAR integration sync mode
     */
    async updateSyncMode(requestParameters: UpdateSyncModeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateSyncModeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the health status for an XSOAR account mapping.  This endpoint is called by external bi-directional cases sync services to report: - Last sync timestamp - Sync status (success, failed, partial) - Sync details (number of records synced, errors, etc.) - Error messages if any - Integration status  **Use Case:** External sync services should call this endpoint after each sync operation to populate the status of the sync (# records sync\'d, errors, etc.). 
     * Update XSOAR account health status
     */
    async updateXsoarAccountHealthRaw(requestParameters: UpdateXsoarAccountHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XsoarAccountMappingResponse>> {
        if (requestParameters['xsoarAccountId'] == null) {
            throw new runtime.RequiredError(
                'xsoarAccountId',
                'Required parameter "xsoarAccountId" was null or undefined when calling updateXsoarAccountHealth().'
            );
        }

        if (requestParameters['xsoarHealthUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'xsoarHealthUpdateRequest',
                'Required parameter "xsoarHealthUpdateRequest" was null or undefined when calling updateXsoarAccountHealth().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/xsoar-integration/accounts/{xsoarAccountId}/health`;
        urlPath = urlPath.replace(`{${"xsoarAccountId"}}`, encodeURIComponent(String(requestParameters['xsoarAccountId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: XsoarHealthUpdateRequestToJSON(requestParameters['xsoarHealthUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => XsoarAccountMappingResponseFromJSON(jsonValue));
    }

    /**
     * Updates the health status for an XSOAR account mapping.  This endpoint is called by external bi-directional cases sync services to report: - Last sync timestamp - Sync status (success, failed, partial) - Sync details (number of records synced, errors, etc.) - Error messages if any - Integration status  **Use Case:** External sync services should call this endpoint after each sync operation to populate the status of the sync (# records sync\'d, errors, etc.). 
     * Update XSOAR account health status
     */
    async updateXsoarAccountHealth(requestParameters: UpdateXsoarAccountHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XsoarAccountMappingResponse> {
        const response = await this.updateXsoarAccountHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates XSOAR account mapping data without saving
     * Validate XSOAR account mapping data
     */
    async validateXsoarAccountMappingRaw(requestParameters: ValidateXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling validateXsoarAccountMapping().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/xsoar-integration/validate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Validates XSOAR account mapping data without saving
     * Validate XSOAR account mapping data
     */
    async validateXsoarAccountMapping(requestParameters: ValidateXsoarAccountMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.validateXsoarAccountMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const UpdateSyncModeSyncModeEnum = {
    Backfill: 'backfill',
    BiDirectional: 'bi-directional'
} as const;
export type UpdateSyncModeSyncModeEnum = typeof UpdateSyncModeSyncModeEnum[keyof typeof UpdateSyncModeSyncModeEnum];
